import {createContext} from 'react';

const user = null;

export const UserContext = createContext(user);